import { AppPath } from 'appConstants';

// The markers live in localStorage, which every tab shares, so a sign-out or expiry in one tab ends
// the session for the others too.
const storedRefreshExpiry = (): Date | null => {
  try {
    const tokenExpiry = window.localStorage.getItem('ATE');
    const refreshExpiry = window.localStorage.getItem('RTE');
    return tokenExpiry != null && refreshExpiry != null
      ? new Date(refreshExpiry)
      : null;
  } catch {
    return null;
  }
};

/** Whether this browser still holds an unexpired sign-in. */
export const hasLiveSession = (now = new Date()): boolean => {
  const refreshExpiry = storedRefreshExpiry();
  return !!refreshExpiry && refreshExpiry > now;
};

/** Whether this browser held a sign-in whose refresh token has since run out. */
export const hasExpiredSession = (now = new Date()): boolean => {
  const refreshExpiry = storedRefreshExpiry();
  return !!refreshExpiry && refreshExpiry <= now;
};

export const signInPathFor = (pathname: string): string => {
  const area = pathname.replace(/^\/+/, '');
  return area
    ? `${AppPath.SIGN_IN}?area=${encodeURIComponent(area)}`
    : AppPath.SIGN_IN;
};
